import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import EmptyTextarea from './EmptyTextarea';
import ClientProvider from './client';
export default createDemo(import.meta.url, EmptyTextarea, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/textarea-autosize/demos/empty-textarea/EmptyTextarea.tsx",
    "fileName": "EmptyTextarea.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import TextareaAutosize from '@mui/material/TextareaAutosize';\n\nexport default function EmptyTextarea() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <TextareaAutosize\n      aria-label=\"empty textarea\"\n      placeholder=\"Empty\"\n      style={{ width: 200 }}\n    />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 11,
        "focusedLines": 5,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import TextareaAutosize from '@mui/material/TextareaAutosize';\n\nexport default function EmptyTextarea() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <TextareaAutosize\n      aria-label=\"empty textarea\"\n      placeholder=\"Empty\"\n      style={{ width: 200 }}\n    />\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 5
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "TextareaAutosize"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 6
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "empty textarea",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 7
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "placeholder"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Empty",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "style"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "width"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "200"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            "    />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 11,
    "focusedLines": 5,
    "collapsible": true,
    "externals": [
      "@mui/material/TextareaAutosize"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
